import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon, StarIcon } from './icons/Icons';
import { useLanguage } from '../LanguageContext';
export const WhyUs = () => {
  const {
    language
  } = useLanguage();
  const comparisonData = [{
    other: language === 'es' ? 'Tratamientos genéricos "para toda piel"' : 'Generic "for all skin types" treatments',
    us: language === 'es' ? 'Protocolo personalizado para TU piel' : 'Personalized protocol for YOUR skin'
  }, {
    other: language === 'es' ? 'Atención rápida sin seguimiento' : 'Fast attention without follow-up',
    us: language === 'es' ? 'María Fernanda conoce tu piel y tu historia' : 'María Fernanda knows your skin and your story'
  }, {
    other: language === 'es' ? 'Productos de stock sin análisis previo' : 'Stock products without prior analysis',
    us: language === 'es' ? 'Evaluación real antes de cada procedimiento' : 'Real evaluation before every procedure'
  }, {
    other: language === 'es' ? 'Resultados temporales' : 'Temporary results',
    us: language === 'es' ? 'Transformación visible y progresiva' : 'Visible and progressive transformation'
  }, {
    other: language === 'es' ? 'Solo un servicio estético' : 'Just an aesthetic service',
    us: language === 'es' ? 'Esthetician + Medical Assistant — doble expertise' : 'Esthetician + Medical Assistant — double expertise'
  }, {
    other: language === 'es' ? 'Un spa más en Filadelfia' : 'Just another spa in Philadelphia',
    us: language === 'es' ? 'El studio donde Philadelphia se transforma' : 'The studio where Philadelphia transforms'
  }];
  const reasons = [{
    title: language === 'es' ? 'RESULTADOS VISIBLES' : 'VISIBLE RESULTS',
    desc: language === 'es' ? 'No trabajamos con promesas vacías. Cada tratamiento está diseñado para que veas la diferencia — muchas desde la primera sesión.' : 'We do not work with empty promises. Every treatment is designed so you see the difference — many from the first session.'
  }, {
    title: language === 'es' ? 'TECNOLOGÍA AVANZADA' : 'ADVANCED TECHNOLOGY',
    desc: language === 'es' ? 'Laser, PRP, Dermapen, IV Therapy — utilizamos las tecnologías más efectivas del mercado, aplicadas con precisión y cuidado.' : 'Laser, PRP, Dermapen, IV Therapy — we use the most effective technologies on the market, applied with precision and care.'
  }, {
    title: language === 'es' ? 'PRODUCTOS DE ALTA CALIDAD' : 'HIGH QUALITY PRODUCTS',
    desc: language === 'es' ? 'Solo utilizamos productos probados, seguros y de alta performance — porque tu piel merece lo mejor, no lo más barato.' : 'We only use proven, safe, and high-performance products — because your skin deserves the best, not the cheapest.'
  }];
  return <section id="por-que" className="py-12 md:py-16 bg-brand-pink relative" data-id="element-448">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-449">
        <div className="text-center mb-8 md:mb-10" data-id="element-450">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-4" data-id="element-451">
            {language === 'es' ? 'Por Qué Skin Glow Studio 22' : 'Why Skin Glow Studio 22'}
          </h2>
          <p className="text-xl text-brand-bronze font-serif italic" data-id="element-452">
            {language === 'es' ? 'No todos los studios son iguales. Este es diferente.' : 'Not all studios are the same. This one is different.'}
          </p>
        </div>

        {/* Comparison Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-2xl shadow-sm border border-brand-gold/20 overflow-hidden mb-10 md:mb-12" data-id="element-453">
          <div className="grid grid-cols-2 bg-brand-blush border-b border-brand-gold/20" data-id="element-454">
            <div className="p-6 text-center border-r border-brand-gold/20" data-id="element-455">
              <h3 className="text-sm md:text-base font-medium text-brand-charcoal/60 uppercase tracking-wider" data-id="element-456">
                {language === 'es' ? 'Lo que encuentras en otros lugares' : 'What you find elsewhere'}
              </h3>
            </div>
            <div className="p-6 text-center bg-brand-gold/5" data-id="element-457">
              <h3 className="text-sm md:text-base font-medium text-brand-bronze uppercase tracking-wider" data-id="element-458">
                {language === 'es' ? 'Lo que encuentras en Skin Glow Studio 22' : 'What you find at Skin Glow Studio 22'}
              </h3>
            </div>
          </div>

          <div className="divide-y divide-brand-cream" data-id="element-459">
            {comparisonData.map((row, idx) => <div key={idx} className="grid grid-cols-2 hover:bg-brand-blush/30 transition-colors" data-id="element-460">
                <div className="p-4 md:p-6 border-r border-brand-cream flex items-center space-x-3" data-id="element-461">
                  <div className="text-brand-charcoal/30 flex-shrink-0" data-id="element-462">
                    <XIcon size={18} data-id="element-463" />
                  </div>
                  <span className="text-sm md:text-base text-brand-charcoal/70" data-id="element-464">
                    {row.other}
                  </span>
                </div>
                <div className="p-4 md:p-6 flex items-center space-x-3 bg-brand-gold/5" data-id="element-465">
                  <div className="text-brand-gold flex-shrink-0" data-id="element-466">
                    <CheckIcon size={18} data-id="element-467" />
                  </div>
                  <span className="text-sm md:text-base font-medium text-brand-charcoal" data-id="element-468">
                    {row.us}
                  </span>
                </div>
              </div>)}
          </div>
        </motion.div>

        {/* 3 Reasons */}
        <div className="text-center mb-6" data-id="element-469">
          <p className="text-lg font-medium text-brand-charcoal flex items-center justify-center space-x-4" data-id="element-470">
            <span className="h-px w-8 bg-brand-gold" data-id="element-471"></span>
            <span data-id="element-472">
              {language === 'es' ? 'Tres razones por las que confiar en nosotras:' : 'Three reasons to trust us:'}
            </span>
            <span className="h-px w-8 bg-brand-gold" data-id="element-473"></span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-474">
          {reasons.map((reason, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: idx * 0.2
        }} className="text-center p-6" data-id="element-475">
              <div className="w-12 h-12 mx-auto rounded-full bg-brand-blush border border-brand-gold/30 flex items-center justify-center text-brand-gold mb-6" data-id="element-476">
                <span className="font-serif text-xl" data-id="element-477">{idx + 1}</span>
              </div>
              <h4 className="text-lg font-medium text-brand-charcoal mb-4 tracking-wide" data-id="element-478">
                {reason.title}
              </h4>
              <p className="text-brand-charcoal/70 leading-relaxed text-sm" data-id="element-479">
                {reason.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};